export const OPEN_NOTIFICATION_PANEL_EVENT = "bidz:open-notification-panel";

export const openNotificationPanel = () => {
  window.dispatchEvent(new Event(OPEN_NOTIFICATION_PANEL_EVENT));
};
